export default "__VITE_ASSET__D8GED18___"